import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  [ORDER_FULFILLMENT_STATUSES.REJECTED]: 'Cancelado',
  [ORDER_FULFILLMENT_STATUSES.CREATED]: 'Recibido',
  [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: 'Confirmado',
  [ORDER_FULFILLMENT_STATUSES.PREPARING]: 'Preparando',
  [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: 'En camino',
  [ORDER_FULFILLMENT_STATUSES.READY]: 'Listo',
  status: {
    actual: 'Actual',
    pending: 'Pendiente',
  },
  warning_label: {
    pickup_time_changed: '{{company}} cambió la hora de {{initialTime}} a {{currentTime}}',
  },
  labels: {
    order_number: 'N.º de pedido: {{number}}',
    today: 'Hoy',
  },
};
